export const CONTACT_US = "https://beta.measurable.ai:8080/v1/api/contactus"

export const SUBSCRIBE = "https://beta.measurable.ai:8080/v1/api/subscribe"

export const REQUEST_FOOD_DELIVERY_REPORT =
  "https://beta.measurable.ai:8080/v1/api/request-annual-report"

export const REQUEST_RIDE_HAILING_REPORT =
  "https://beta.measurable.ai:8080/v1/api/request-reports/ride-hailing-2023"

export const REQUEST_DIGITAL_ECONOMY_REPORT_2024 =
  "https://beta.measurable.ai:8080/v1/api/request-reports/digital-economy-annual-report-2024"

export const REQUEST_MIDDLE_EAST_ONLINE_DELIVERY_REPORT =
  "https://beta.measurable.ai:8080/v1/api/request-reports/middle-east-online-delivery-report"
